<template>
  <Tooltip max-width="400" :content="getConditionsLabel()" :disabled="conditions.length === 0 || disabled">
    <slot />
  </Tooltip>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    conditions: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      operator: {
        gt: '大于',
        lt: '小于',
        gte: '大于等于',
        lte: '小于等于',
        equals: '等于',
        all: '包含所有',
        any: '包含任一',
      },
    }
  },
	computed: {
    ...mapState('setting', ['sysVars']),
    ...mapState('intents', [
			'intents'
    ]),
	},
  methods: {
    getConditionsLabel() {
      const label = this.conditions.map(this.getConditionLabel)
      return label.join('\n')
    },
    getConditionLabel(condition) {
      const { rule = '', op, value } = condition;
			let varName = rule.split(':')[1];
			if (rule.indexOf('sys:') === 0) {
				const sysVar = this.sysVars.find(sysVar => sysVar.id === varName);
				varName = sysVar?.name;
			} else if (rule.indexOf('intent') === 0) {
				const intentId = rule.slice(4);
				const intent = this.intents.find(intent => intent.id === varName);
				varName = `${intent?.name || ''} 次数`;
			}
      return `${varName} ${this.operator[op]} ${value}`
    },
  }
}
</script>
